import { Controller, useFormContext } from 'react-hook-form';
import { Autocomplete } from '@ds';
import { Hub } from '@/api/apis/facilities';
import { renderAutocompleteItem } from '@/utils/helpers';
import { useHubsSearchableList } from '@/hooks/useHubsSearchableList';

type ControlledHubAutocompleteProps = {
  name: string;
  'aria-label'?: string;
  isDisabled?: boolean;
  onSelectionChange?: (hub: Hub | null) => void;
};

export const ControlledHubAutocomplete = ({
  name,
  'aria-label': ariaLabel = 'Hub',
  isDisabled,
  onSelectionChange,
}: ControlledHubAutocompleteProps) => {
  const { control } = useFormContext();
  const {
    hubs,
    list: hubsList,
    isLoading: isHubsListLoading,
    setSearchValue: onHubSearch,
  } = useHubsSearchableList({ searchBy: ['name', 'code'] });

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, ref, onChange, ...field }, fieldState: { invalid, error } }) => (
        <Autocomplete
          allowsCustomValue={false}
          placeholder="Choose an option"
          aria-label={ariaLabel}
          items={hubsList}
          isLoading={isHubsListLoading}
          onInputChange={(text) => {
            onHubSearch(text);
            if (!text) {
              onChange(null);
            }
          }}
          isInvalid={invalid}
          isDisabled={isDisabled}
          errorMessage={error?.message}
          selectedKey={value || null}
          onSelectionChange={(key) => {
            onChange(key?.toString() ?? null);
            onSelectionChange?.(hubs.find((h) => h.id === key) ?? null);
          }}
          {...field}
        >
          {renderAutocompleteItem}
        </Autocomplete>
      )}
    />
  );
};
